'use client';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { COLORS } from '../../constants';

export const TextEllipsis = ({ children, maxLength }: { children: string; maxLength?: number }) => {
  const [messageShrinked, setMessageShrinked] = useState(true);
  const max = maxLength || 80;
  return (
    <>
      {children.length > max && messageShrinked ? `${children.slice(0, max)}...` : children}
      {children.length > max && (
        <Typography
          component="span"
          sx={{ color: `${COLORS.text.main} !important`, fontSize: 'inherit', cursor: 'pointer' }}
          onClick={() => setMessageShrinked((current) => !current)}
        >
          {' '}
          (Ver {messageShrinked ? 'más' : 'menos'})
        </Typography>
      )}
    </>
  );
};
